import { useState } from "react";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";

// Ruvixx brand palette (see theme-and-brand.md) offered as quick picks.
const PRESET_COLORS = [
  "#FF6B35",
  "#F34A02",
  "#FC926B",
  "#FBCAB8",
  "#24B388",
  "#0D7757",
  "#7CDBBE",
  "#057B9F",
  "#3D3D3D",
  "#E8E8E8",
];

const ColorPicker = ({
  color = "#ccc",
  small = false,
  setColor,
  ariaLabel = "Choose color",
  children,
}) => {
  const [open, setOpen] = useState(false);

  const swatch = (
    <span
      className={cn(
        "tw:inline-block tw:rounded-full tw:border tw:border-[var(--color-border)]",
        small ? "tw:size-5" : "tw:size-8"
      )}
      style={{ backgroundColor: color }}
    />
  );

  // Without a setter the swatch is a read-only indicator (e.g. a table cell).
  if (!setColor) {
    return swatch;
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        type="button"
        aria-label={ariaLabel}
        className="tw:inline-flex tw:cursor-pointer tw:items-center tw:gap-3 tw:rounded-md tw:hover:bg-[var(--color-surface-raised)]"
      >
        {swatch}
        {children}
      </PopoverTrigger>
      <PopoverContent align="start" className="tw:w-auto tw:gap-3">
        <div className="tw:grid tw:grid-cols-5 tw:gap-2">
          {PRESET_COLORS.map(preset => (
            <button
              key={preset}
              type="button"
              aria-label={preset}
              onClick={() => setColor(preset)}
              className={cn(
                "tw:size-6 tw:cursor-pointer tw:rounded-sm tw:border tw:border-[var(--color-border)]",
                color?.toLowerCase() === preset.toLowerCase() &&
                  "tw:ring-2 tw:ring-primary tw:ring-offset-1"
              )}
              style={{ backgroundColor: preset }}
            />
          ))}
        </div>
        <label className="tw:flex tw:items-center tw:gap-2 tw:text-sm tw:text-[var(--color-text-secondary)]">
          Custom
          <input
            type="color"
            value={color || "#000000"}
            onChange={e => setColor(e.target.value)}
            className="tw:h-8 tw:w-12 tw:cursor-pointer tw:rounded tw:border tw:border-[var(--color-border)] tw:bg-transparent"
          />
        </label>
      </PopoverContent>
    </Popover>
  );
};

export default ColorPicker;
